import React from "react";
import { useTable } from "../../Components/useTable";

const CoinsHistory = () => {
  const type = "Send Rcoins";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "fromUserCode", numeric: false, label: "Sender RID" },
    { id: "fromUserName", numeric: false, label: "Sender Name" },
    { id: "fromUserEmail", numeric: false, label: "Sender Email" },
    { id: "fromUserPhone", numeric: false, label: "Sender Phone No" },
    { id: "userWalletCode", numeric: false, label: "Receiver RID" },
    { id: "userName", numeric: false, label: "Receiver Name" },
    { id: "userEmail", numeric: false, label: "Receiver Email" },
    { id: "userPhone", numeric: false, label: "Receiver Phone No" },
    { id: "rcoinreceive", numeric: false, label: "Send Rcoins" },
    { id: "reason", numeric: false, label: "Reason" },
    { id: "created", numeric: false, label: "Date" },
    // { id: "userWalletId", numeric: false, label: "User Wallet Id" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default CoinsHistory;
